import { Component, Input } from "@angular/core";
import { DataList } from "../datalist.component";

@Component({
    standalone: false,
    selector: "item",
    template: "",
})
export class DataListItem {
    @Input() header;
    @Input() name;
    @Input() description;
    @Input() id;
    @Input() url;

    constructor(list: DataList) {
        list.addItem(this);
    }
}
